import { Purchases } from "../views/Purchases/Purchases";

import AssessmentIcon from "@material-ui/icons/Assessment";

export const purchasesRoutes = [
  {
    collapse: true,
    name: "Compras",
    icon: AssessmentIcon,
    state: "purchasesSection",
    inSidebar: true,
    isProtected: true,
    rule: "PURCHASES",
    views: [
      {
        path: "/compras",
        name: "Compras",
        mini: "CP",
        component: Purchases,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "PURCHASES",
      },
    ],
  },
]